import type { SizeModifier, StyleProps } from '../vibe.types';

// Order is important. smaller sizes will be overridden by larger sizes
const sizes: SizeModifier[] = ['base', 'xs', 'sm', 'md', 'lg', 'xl'];

export const isResponsiveMatch = (
  givenSize: SizeModifier | undefined,
  matches: SizeModifier
): boolean => {
  if (!givenSize) {
    return false;
  }

  return sizes.indexOf(givenSize) >= sizes.indexOf(matches);
};

export const applyResponsiveStyles = (
  givenSize: SizeModifier | undefined,
  styles: Partial<Record<SizeModifier, StyleProps>>
): StyleProps => {
  return sizes.reduce<StyleProps>((style, size) => {
    if (isResponsiveMatch(givenSize, size)) {
      return { ...style, ...(styles[size] ?? {}) };
    }
    return style;
  }, {});
};
